/**
 * @ngdoc service
 * @name common.service:ItxContactSvc
 * @requires $q
 * @description
 * Contact service
 */
(function () {
    'use strict';

    angular.module('itxApp.common').service('ItxContactSvc', ItxContactSvc);

    ItxContactSvc.$inject = ['$q', 'CmsConfigSvc', 'itxAkamaiSvc'];

    function ItxContactSvc($q, CmsConfigSvc, itxAkamaiSvc) {
        var _this = this;

        _this.store = {
            timeWeek: {
                from: '',
                to: ''
            },
            timeWeekend: {
                from: '',
                to: ''
            },
            timeSunday: {
                from: '',
                to: ''
            },
            chatOnline: false
        };

        var service = {
            sendSuggestion: sendSuggestion,
            sendContactForm: sendContactForm,
            getStateOfStore: getStateOfStore
        };

        return service;

        /**
         * @ngdoc method
         * @name getStateOfStore
         * @methodOf common.service:ItxContactSvc
         * @description Calcula la hora de la zona horaria del cliente y la hora de la zona horaria
         * 			   de la tienda para determinar si la misma se encuentra en horario de atención.
         */

        function getStateOfStore() {
            var deferred = $q.defer();

            CmsConfigSvc.getProperty('horariocallcenterchatbot')
                .then(function (res) {
                    itxAkamaiSvc.getDate().then(function (resAkamai) {
                        var actualTimeUtc0 = moment(resAkamai);
                        var timeFromUTC = '';
                        var timeToUTC = '';
                        // Añado el "res.sunday" a la condición para que funcione como siempre en caso de no tener configurado el domingo
                        if (isSunday() && res.sunday) {
                            timeFromUTC = res.sunday.fromUTC;
                            timeToUTC = res.sunday.toUTC;
                        } else if (isWeekend()) {
                            timeFromUTC = res.saturday.fromUTC;
                            timeToUTC = res.saturday.toUTC;
                        } else {
                            timeFromUTC = res.weekdays.fromUTC;
                            timeToUTC = res.weekdays.toUTC;
                        }
                        _this.store.chatOnline = isStoreOpen(
                            actualTimeUtc0,
                            timeFromUTC,
                            timeToUTC
                        );
                        setTimeStoreFormat(res);
                        deferred.resolve(_this.store);
                    });
                })
                .catch(function (err) {
                    if (err) {
                        _this.store.chatOnline = false;
                        deferred.resolve(_this.store);
                    }
                });
            return deferred.promise;
        }

        function isStoreOpen(actualDateUTC, timeFrom, timeTo) {
            var init = moment(actualDateUTC, 'YYYY-MM-DD HH:mm:ss').set({
                hour: moment(timeFrom).utc().hour(),
                minute: moment(timeFrom).utc().minutes(),
                seconds: moment(timeFrom).utc().seconds()
            });
            var end = moment(actualDateUTC, 'YYYY-MM-DD HH:mm:ss').set({
                hour: moment(timeTo).utc().hour(),
                minute: moment(timeTo).utc().minutes(),
                seconds: moment(timeTo).utc().seconds()
            });

            return actualDateUTC.isBetween(init, end);
        }

        function isWeekend() {
            var isWeek = true;
            var actualDay = moment().isoWeekday();
            if (actualDay < 6) {
                isWeek = false;
            }
            return isWeek;
        }

        function isSunday() {
            var isSunday = true;
            var actualDay = moment().isoWeekday();
            if (actualDay != 7) {
                isSunday = false;
            }
            return isSunday;
        }

        function setTimeStoreFormat(value) {
            if (value.weekdays) {
                _this.store.timeWeek.from = value.weekdays.from.slice(0, 2) + ':' + value.weekdays.from.slice(2);
                _this.store.timeWeek.to = value.weekdays.to.slice(0, 2) + ':' + value.weekdays.to.slice(2);
            }
            if (value.saturday) {
                _this.store.timeWeekend.from = value.saturday.from.slice(0, 2) + ':' + value.saturday.from.slice(2);
                _this.store.timeWeekend.to = value.saturday.to.slice(0, 2) + ':' + value.saturday.to.slice(2);
            }
            if (value.sunday) {
                _this.store.timeSunday.from = value.sunday.from.slice(0, 2) + ':' + value.sunday.from.slice(2);
                _this.store.timeSunday.to = value.sunday.to.slice(0, 2) + ':' + value.sunday.to.slice(2);
            }
        }

        /**
         * @ngdoc method
         * @name sendSuggestion
         * @methodOf  common.service:ItxContactSvc
         * @description
         * Send suggestion
         * @param {string} suggestion Suggestion data
         * @returns {promise} suggestion response
         */
        function sendSuggestion(suggestion) {
            var deferred = $q.defer();

            var action = {
                action: 'user:contact',
                params: {
                    storeId: inditex.iStoreId,
                    languageId: inditex.iLangId
                },
                data: suggestion
            };

            joyr.rest
                .xRestExecute([action])
                .done(function () {
                    deferred.resolve();
                })
                .Catch(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name sendContactForm
         * @methodOf  common.service:ItxContactSvc
         * @description
         *
         */
        function sendContactForm(contactModel) {
            var deferred = $q.defer();

            var contact = _.clone(contactModel);
            contact.privacyPolicy = true;
            contact.phone = contact.prefix + ' ' + contact.phones[0].subscriberNumber;
            delete contact.storeType;
            delete contact.privacyPolicyAccepted;
            delete contact.newsletterAccepted;
            delete contact.termsConditions;
            delete contact.prefix;
            contact.type = 0;

            var action = {
                action: 'user:contact',
                params: {
                    storeId: inditex.iStoreId,
                    languageId: inditex.iLangId
                },
                data: contact
            };

            joyr.rest
                .xRestExecute([action])
                .done(function () {
                    deferred.resolve();
                })
                .Catch(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }
    }
})();
